import { Language } from '../i18n/constants';
import { makeAnonymousFetcher } from './anonymous-fetcher';

type Options = {
  url: string;
  retrieveAccessToken: () => Promise<string>;
  language: Language;
  headers?: HeadersInit;
};

/**
 * This function is used to create a data fetcher for Tanstack query and should not be used for mutations.
 */
export const makeAuth0BearerAuthFetcher =
  <T>({ url, retrieveAccessToken, language, headers }: Options) =>
  async (): Promise<T> => {
    const accessToken = await retrieveAccessToken();

    const authHeader = {
      Authorization: 'Bearer ' + accessToken,
    };

    return makeAnonymousFetcher<T>({ url, language, headers: { ...authHeader, ...headers } })();
  };
